import React from 'react';
import { styles } from './NoResultsView.css';

type NoResultsViewProps = {
  title: string;
  children: React.ReactNode;
};

const NoResultsView = ({ title, children }: NoResultsViewProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {children ? <div className={styles.contentContainer}>{children}</div> : null}
      </div>
    </div>
  );
};

export { NoResultsView };
